import {seoMetadata as SeoMetadata} from "@next/utils"
import State from "../../../../models/State"
import {urlSanitiser} from "../../../httpUrlTrimmer"
import {NO_INDEX_NO_FOLLOW_META_ROBOTS} from "../../../../config/constants"
import {NO_INDEX_NO_FOLLOW_CONSTANTS} from "../constants"

interface SeoMetadata {
    title: string
    keywords: string
    description: string
    robots: string
    canonical?: string
}

export const updateSeoMetaDataIndexing = (state: State, seoMetaData: SeoMetadata): SeoMetadata => {
    const updateSeoMetaData: SeoMetadata = {...seoMetaData}
    const {url} = state.request
    const sanitisedUrl = urlSanitiser(url).replace(/\?.*$/, "")
    if (NO_INDEX_NO_FOLLOW_CONSTANTS.some(c => sanitisedUrl.includes(c))) {
        updateSeoMetaData.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
    }
    return updateSeoMetaData
}
